import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import { selectInboxTab, setShowTools, setTaggingActive } from 'actions/index';
import { getSelectedInboxTab, getIsExpertDashboardOpened, getSimplrTaggingActive } from 'extractFromState';
import {
  getLiveChatUnansweredAssignedTickets,
  getLiveChatUnviewedAssigned,
  getNonLiveChatUnansweredAssignedTickets,
  getNonLiveChatUnviewedAssigned,
} from 'selectors/tickets';
import InboxTabComponent from '../../components/inboxPanel/InboxTab/InboxTab';
import { CountBox } from 'components/inboxPanel/InboxTab/InboxTab.styles';

const IncomingCountBox = styled(CountBox)`
  background-color: #44b2e0;
`;

const AssignedChatsBox = styled(CountBox)`
  background-color: #d9a145;
`;

const AssignedNonChatsBox = styled(CountBox)`
  background-color: #6cb67f;
`;

const DisabledCountBox = styled(CountBox)`
  background-color: #eef3f7;
`;

export class InboxTabPickerComponent extends React.PureComponent {
  handleTabSelect(tab) {
    const { simplrTaggingActive, onTabSelect } = this.props;
    if (!simplrTaggingActive) {
      onTabSelect(tab);
    }
  }

  render() {
    const {
      isAdmin,
      selectedInboxTab,
      numNominated,
      numNonLiveChatUnansweredAssigned,
      numLiveChatUnansweredAssigned,
      numLiveChatUnviewedAssigned,
      numNonLiveChatUnviewedAssigned,
      unreadNominatedTicketIds,
      simplrTaggingActive,
      isExpertDashboardOpened,
    } = this.props;

    if (isAdmin) {
      return (
        <InboxTabHolder>
          <InboxTabComponent
            label="ALL"
            CountBox={simplrTaggingActive ? DisabledCountBox : IncomingCountBox}
            onClick={() => this.handleTabSelect('all')}
            hasAlert={false}
            isSelected={selectedInboxTab === 'all'}
            disabled={simplrTaggingActive}
          />
          <InboxTabComponent
            label="ESCALATED"
            CountBox={simplrTaggingActive ? DisabledCountBox : IncomingCountBox}
            onClick={() => this.handleTabSelect('nominated')}
            count={numNominated}
            hasAlert={false}
            isSelected={selectedInboxTab === 'nominated'}
            disabled={simplrTaggingActive}
          />
          <InboxTabComponent
            label="MY ITEMS"
            CountBox={simplrTaggingActive ? DisabledCountBox : AssignedNonChatsBox}
            onClick={() => this.handleTabSelect('assigned')}
            count={numNonLiveChatUnansweredAssigned + numLiveChatUnansweredAssigned}
            hasAlert={numLiveChatUnviewedAssigned + numNonLiveChatUnviewedAssigned > 0}
            isSelected={selectedInboxTab === 'assigned'}
            disabled={simplrTaggingActive}
          />
        </InboxTabHolder>
      );
    }

    return (
      <InboxTabHolder>
        <TabWrapper>
          <InboxTabComponent
            label="INCOMING"
            CountBox={simplrTaggingActive ? DisabledCountBox : IncomingCountBox}
            onClick={() => this.handleTabSelect('nominated')}
            hasAlert={unreadNominatedTicketIds.length > 0}
            isSelected={selectedInboxTab === 'nominated'}
            count={numNominated}
            disabled={simplrTaggingActive || isExpertDashboardOpened}
          />
        </TabWrapper>
        <InboxTabComponent
          label="MY LIVE CHATS"
          CountBox={simplrTaggingActive ? DisabledCountBox : AssignedChatsBox}
          onClick={() => this.handleTabSelect('live_chat')}
          hasAlert={numLiveChatUnviewedAssigned > 0}
          isSelected={selectedInboxTab === 'live_chat'}
          count={numLiveChatUnansweredAssigned}
          disabled={simplrTaggingActive || isExpertDashboardOpened}
        />
        <InboxTabComponent
          label="MY MESSAGES"
          CountBox={simplrTaggingActive ? DisabledCountBox : AssignedNonChatsBox}
          onClick={() => this.handleTabSelect('assigned')}
          hasAlert={numNonLiveChatUnviewedAssigned > 0}
          isSelected={selectedInboxTab === 'assigned'}
          count={numNonLiveChatUnansweredAssigned}
          disabled={simplrTaggingActive || isExpertDashboardOpened}
        />
      </InboxTabHolder>
    );
  }
}

export const mapStateToProps = (state) => ({
  isAdmin: state.user.isAdmin,
  selectedInboxTab: getSelectedInboxTab(state),
  numNominated: state.tickets.nominatedTickets.allTickets.length,
  numNonLiveChatUnansweredAssigned: getNonLiveChatUnansweredAssignedTickets(state).length,
  numLiveChatUnansweredAssigned: getLiveChatUnansweredAssignedTickets(state).length,
  numLiveChatUnviewedAssigned: getLiveChatUnviewedAssigned(state).length,
  numNonLiveChatUnviewedAssigned: getNonLiveChatUnviewedAssigned(state).length,
  unreadNominatedTicketIds: state.unreadNominatedTicketIds,
  simplrTaggingActive: getSimplrTaggingActive(state),
  conversation: state.conversation,
  tickets: state.tickets,
  notificationsQueue: state.notifications.tabNotificationsQueue,
  expertId: state.user.id,
  selectedTicketId: state.selectedTicketId,
  isExpertDashboardOpened: getIsExpertDashboardOpened(state),
});

const mapDispatchToProps = (dispatch) => ({
  setTaggingFalse() {
    dispatch(setTaggingActive(false));
  },
  onTabSelect(tab) {
    dispatch(setShowTools(false));
    dispatch(selectInboxTab(tab));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InboxTabPickerComponent);

const InboxTabHolder = styled.div`
  display: inline-flex;
  margin: 0;
  padding-top: 1px;
  overflow: visible;
  z-index: 100;
  position: relative;
`;

const TabWrapper = styled.div`
  position: relative;
`;
